import Vue from 'vue'
import Router from 'vue-router'

import WIAHome from '@/components/WIA-Home'
import WIAStep1 from '@/components/WIA-Step1'
import WIAStep2 from '@/components/WIA-Step2'
import WIAStep3 from '@/components/WIA-Step3'
import WIAResult from '@/components/WIA-Result'
import WIACategories from '@/components/seo/WIA-Categories'
import WIASeoL1Issue from '@/components/seo/WIA-SeoL1Issue'
import WIASeoL2Issue from '@/components/seo/WIA-SeoL2Issue'
import WIASeoL3Issue from '@/components/seo/WIA-SeoL3Issue'
import WIASeoResultIssue from '@/components/seo/WIA-SeoResultIssue'

Vue.use(Router)

let basePath = document.location.href.includes('localhost') ? null : document.location.pathname.split('--').reverse().pop()
export default new Router({
  mode: 'history',
  base: basePath,
  routes: [
    {
      path: '/',
      name: 'WIA-Home',
      component: WIAHome
    },
    {
      path: '/--step1',
      name: 'WIAStep1',
      component: WIAStep1
    },
    {
      path: '/--step2',
      name: 'WIAStep2',
      component: WIAStep2
    },
    {
      path: '/--step3',
      name: 'WIAStep3',
      component: WIAStep3
    },
    {
      path: '/--result',
      name: 'WIAResult',
      component: WIAResult
    },
    {
      path: '/--all-categories',
      name: 'WIA-Categories',
      component: WIACategories
    },
    {
      path: '/--category-issue',
      name: 'WIA-SeoL1Issue',
      component: WIASeoL1Issue
    },
    {
      path: '/--l1-issue',
      name: 'WIA-SeoL2Issue',
      component: WIASeoL2Issue
    },
    {
      path: '/--issues',
      name: 'WIA-SeoL3Issue',
      component: WIASeoL3Issue
    },
    {
      path: '/--result-issue',
      name: 'WIA-SeoResultIssue',
      component: WIASeoResultIssue
    }
  ]
})
